import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center w-full pad-m" }
const _hoisted_2 = ["src"]

import { ref, computed } from 'vue';
import { Menu, MenuMethods } from 'primevue';
import SharedService from '@/services/SharedService';


export default /*@__PURE__*/_defineComponent({
  __name: 'esPatientActionMenu',
  props: {
    itemUuid: {},
    textToDisplay: {},
    labelAction: {},
    iconAction: {},
    pathIconAction: {},
    iconMenuClass: {}
  },
  emits: ['menuAction',],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const menu = ref<MenuMethods>();

const emits = __emit;

const items = computed(()=> props.textToDisplay ? 
    [{
        label: props.textToDisplay,
        items: [{
            ref: 'entry-action',
            label: props.labelAction,
            icon: props.iconAction,
            pathIcon: props.pathIconAction,
            command: () => {
                emits('menuAction', props.itemUuid);
            }
        }]
    }]
    :
    [{
        ref: 'entry-action',
        label: props.labelAction,
        icon: props.iconAction,
        pathIcon: props.pathIconAction,
        command: () => {
          emits('menuAction', props.itemUuid);
        }
    }]
);

const toggle = (event: PointerEvent) => {
  menu.value.toggle(event);
}

return (_ctx: any,_cache: any) => {
  const _component_es_button_icon = _resolveComponent("es-button-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_es_button_icon, {
      "aria-controls": `overlay_tmenu_${_ctx.itemUuid}`,
      "aria-haspopup": "true",
      icon: "three-vertical-dots",
      folder: "shareIcons",
      styles: _ctx.iconMenuClass ? _ctx.iconMenuClass : 'icon-grey-style',
      class: "square-29 justify-center",
      onClick: toggle
    }, null, 8, ["aria-controls", "styles"]),
    _createVNode(_unref(Menu), {
      class: "card",
      ref_key: "menu",
      ref: menu,
      id: `overlay_tmenu_${_ctx.itemUuid}`,
      model: items.value,
      popup: ""
    }, {
      item: _withCtx(({ item, props }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("a", _mergeProps(props.action, { class: "w-full justify-center menu-link" }), [
            (item.icon)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _unref(SharedService).getIcon(item.icon, false, item.pathIcon),
                  class: "es-tab-settings-icons"
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(item.label), 1)
          ], 16)
        ])
      ]),
      _: 1
    }, 8, ["id", "model"])
  ], 64))
}
}

})